import { render, staticRenderFns } from "./reversal.vue?vue&type=template&id=aa664d1a&scoped=true"
import script from "./reversal.vue?vue&type=script&lang=js"
export * from "./reversal.vue?vue&type=script&lang=js"
import style0 from "./reversal.vue?vue&type=style&index=0&id=aa664d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa664d1a",
  null
  
)

export default component.exports